import {Col, Row} from "react-bootstrap";
import EditIcon from "@mui/icons-material/Edit";
import {useEffect} from "react";
import {useCreateProject} from "../Behaviors/projects";
import {useAsperaApi} from "../aspera/aspera";
import { useWorkspace } from "../Behaviors/workspace";
import {Folder} from "./Folder";
import { version } from "./../autobuild_version";

function getVersion() {
    return (
        <>
            <span className="h6">v{version}</span>
        </>
    );
}

export const WorkspaceView = () => {
    const {watchForAsperaEvents, stopWatchingForAsperaEvents} = useAsperaApi();

    // Subscribe to Aspera events
    useEffect(() => {
        watchForAsperaEvents();
        return stopWatchingForAsperaEvents;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const {
        drafts,
        pending,
        inProgress,
        needsAttention,
        completed,
    } = useWorkspace();

    const { createProject } = useCreateProject();
    return <>
        <Row className=" h-100">
            <div id={"workspaceContainer"} >
                <Col className="h-100">
                    <Row className="mt-3">
                        <Col>
                            <h3> Ingestion Jobs</h3>
                        </Col>
                    </Row>
                    <Row className="h-90">
                        <table className={"table  workspace  h-100 mt-2 mb-3  "}>
                            <tbody>
                                <tr onClick={async () => {
                                    document.title = "AIT: No product selected";
                                    await createProject();
                                }}>
                                    <td><EditIcon> </EditIcon></td>
                                    <td className="project">New Draft</td>
                                    <td />
                                    <td />
                                </tr>
                                <Folder name={"Drafts"} projects={drafts.sort((a, b) => b.created!.localeCompare(a.created!))} />
                                <Folder name={"Uploading"} projects={pending.sort((a, b) => b.jobStartTime?.localeCompare(a.jobStartTime ?? "") ?? 0)} />
                                <Folder name={"In Progress"} projects={inProgress.sort((a, b) => b.jobStartTime?.localeCompare(a.jobStartTime ?? "") ?? 0)} />
                                <Folder name={"Needs Attention"} projects={needsAttention.sort((a, b) => b.lastModified!.localeCompare(a.lastModified!))} />
                                <Folder name={"Completed"} projects={completed.sort((a, b) => b.lastModified!.localeCompare(a.lastModified!))} />
                            </tbody>
                        </table>
                    </Row>
                    <Row className="appVersion">
                        {getVersion()}
                    </Row>
                </Col>
            </div>
        </Row>
    </>;
};
